import { createBrowserRouter, Navigate } from "react-router";

import ReconciliationLayout from "../Layout/Layout";
import Chargebacks from "../Pages/Reconciliation/Tabs/ChargeBacks/ChargeBacks";
import DsCards from "../Pages/Reconciliation/Tabs/DSCards/DsCards";

import MerchantWidget from "../Pages/MerchantWidget/MerchantWidget";

import { setToken } from "../API/tokenStore";
import {
  exchangeToken,
  getCorporations,
  getUserid,
  userPref,
  Previlages,
  userApproval,
} from "../API/nimbleAPI";
import { handleSessionOut } from "../HelperFunctions/HelperFunctions";
import { v2Clients } from "../API/backendAPI";

async function loader(params) {
  let {
    authId,
    clientName,
    corpId,
    menuId,
    clientId = "F9578C8284FC14824742DF8AB337DB9F0000",
    rowsPerPage = 40,

    merchantName,
    pcID,
    from_todate,
    screentype
  } = params;



  //  if (clientName === "localhost") {
  //   clientName = "localhost:63418";
  //  }

  let clientNameURL;

  if (clientName === "localhost") {
    clientNameURL = `http://localhost:63418/`;
  } else {
    clientNameURL = `https://${clientName}.nimbleproperty.net/`;
  }

  // const clientNameURL = `http://${clientName}/`;
  const journalMenuId = "010000000000000000000000000000000357"
  const mainMerchantMenuId = "010000000000000000000000000000005555"

  const toBeChangeToURLV2 = await v2Clients();
  const isV2 = toBeChangeToURLV2.includes(clientName);
  const clientNameUrlVersion = isV2 ? "v2" : "v1";

  const data = await exchangeToken(clientNameUrlVersion, authId);
  if (!data.success) {
    handleSessionOut();
    throw new Response(null, {
      status: 400,
      statusText: data.error.status,
    });
  }

  const { token, minutesToExpire, refAuth } = data.data;
  // setToken(token);
  setToken(
      token,
      minutesToExpire,
      refAuth,
      clientNameUrlVersion,
      isV2        // Only true for staging5 and staging6
  );

  const corporations = await getCorporations();
  const { Status } = await userApproval();
  const userId = await getUserid();
  const userPreference = await userPref(userId);
  const merchatScreenPrevilage = await Previlages(userId, mainMerchantMenuId);
  const Previlagecheck = await Previlages(userId, menuId, journalMenuId);
  let journal = null;
  let Previlage = [];

  Previlagecheck.forEach((item) => {
    if (item.MenuID === journalMenuId) {
      journal = item;
    } else {
      Previlage.push(item);
    }
  });



  return {
    headerCorporation: corpId === "000000000000000000000000000000000000" ? null : corpId,
    corporations,
    clientId,
    userId,
    rowsPerPage,
    corpId,
    menuId,
    Previlage,
    journal,
    userPreference,
    clientNameURL,
    Status,
    clientName,
    authId,
    menuId, corpId,

    merchantName,
    pcID,
    from_todate,
    screentype,
    merchatScreenPrevilage
  };
}

// /reconciliation/:clientName/:authId/:menuId/:corpId/:merchantName/:pcID/:from_todate/:screentype/:routetype

const router = createBrowserRouter([
  {
    id: "reconciliation",
    // path: "/reconciliation/:clientName/:authId/:menuId/:corpId",
    path: "/reconciliation/:clientName/:authId/:menuId/:corpId/:merchantName?/:pcID?/:from_todate?/:screentype?",
    loader: ({ params }) => loader(params),
    element: <ReconciliationLayout />,
    children: [
      { index: true, element: <Navigate to="ds-cards" replace /> },
      { path: "ds-cards", element: <DsCards /> },
      { path: "chargebacks", element: <Chargebacks /> },
    ],
  },
  {
    path: "/merchant_widget/:clientName/:authId/:menuId/:corpId",
    loader: ({ params }) => loader(params),
    element: <MerchantWidget />,
  },
]);

export default router;
